// extracted by mini-css-extract-plugin
module.exports = {"code-wrap":"CodeHighlighter_code-wrap__nRQHX","copy-tip":"CodeHighlighter_copy-tip__gMEK1","language-tip":"CodeHighlighter_language-tip__DXubX"};